// eslint-disable-next-line import/prefer-default-export
export const UPDATE_ALL_REFERRALS = 'UPDATE_ALL_REFERRALS';
